import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { blogsData } from "../constant";
import img from "../images/Web-developer.svg";
import { Helmet } from "react-helmet-async";

const BlogSkeleton = () => {
  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden animate-pulse">
      <div className="w-full h-48 bg-gray-300"></div>
      <div className="p-4">
        <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
        <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
        <div className="h-4 bg-gray-300 rounded w-5/6"></div>
        <div className="h-8 bg-gray-300 rounded w-1/4 mt-4"></div>
      </div>
    </div>
  );
};

const BlogList = () => {
  const [visibleBlogs, setVisibleBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6; // Number of blogs to load per "page"

  useEffect(() => {
    // Initial load of blogs
    window.scrollTo(0, 0);
    loadMoreBlogs();
  }, []);

  useEffect(() => {
    // Scroll event listener to load more blogs when near bottom
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 350 &&
        !loading
      ) {
        loadMoreBlogs();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleBlogs, loading]);

  const loadMoreBlogs = async () => {
    if (!hasMore) return;
    setLoading(true);

    const startIndex = (currentPage - 1) * blogsPerPage;
    const endIndex = currentPage * blogsPerPage;

    const newBlogs = blogsData.slice(startIndex, endIndex);

    setTimeout(() => {
      if (newBlogs.length === 0) {
        setHasMore(false); // No more blogs to load
      } else {
        setVisibleBlogs((prevBlogs) => [...prevBlogs, ...newBlogs]);
        setCurrentPage((prevPage) => prevPage + 1);
      }
      setLoading(false);
    }, 1000); // Simulate a network delay
  };

  return (
    <>
      <Helmet>
        <title>TeqnoDux | Blogs</title>
        <meta name="description" content="Blogs" />
        <meta property="og:title" content="TeqnoDux | Blogs" />
        <meta
          property="og:description"
          content="TeqnoDux specializes in innovative software development craftsmanship, delivering tailored solutions to empower your business."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="teqnoduxlogo.jpg" />
        <meta property="og:url" content="https://teqnodux.com/blogs" />
        <meta property="og:site_name" content="TeqnoDux" />
        <link rel="canonical" href="https://teqnodux.com/blogs" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "TeqnoDux",
            description:
              "TeqnoDux is a global leader in software development, delivering high-quality, custom software solutions tailored to your needs. Explore our innovative services!",
            provider: {
              "@type": "Organization",
              name: "TeqnoDux",
              url: "https://teqnodux.com/blogs"
            },
            serviceType: [
              "Web Development",
              "Mobile App Development",
              "CRM Consulting",
              "3D Web Solutions"
            ],
            areaServed: "Worldwide",
            image: img,
            url: "https://teqnodux.com/blogs"
          })}
        </script>
      </Helmet>
      <NavBar />
      <div
        className="container mx-auto px-4 sm:px-8 lg:px-20 pt-28 pb-12"
        data-aos="zoom-in"
        id="blogs"
      >
        <h1 className="text-4xl font-bold text-center text-[#377c7d] mb-8">
          Bytes of Brilliance
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ">
          {blogsData.map((blog) => (
            <div
              key={blog.id}
              className="bg-white shadow-lg rounded-lg overflow-hidden group"
            >
              <div className="overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-48 object-cover transform transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="p-4">
                <h2 className="text-2xl font-bold text-[#377c7d]">
                  {blog.title}
                </h2>
                <p className="text-gray-700 mt-2">{blog.summary}</p>
                <Link
                  to={`/blogs/${blog.id}`}
                  className="inline-block mt-4 text-white bg-[#377c7d] hover:bg-[#2b6262] px-4 py-2 rounded-lg"
                >
                  Read More
                </Link>
              </div>
            </div>
          ))}

          {loading &&
            Array.from({ length: 3 }).map((_, index) => (
              <BlogSkeleton key={index} />
            ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogList;
